var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7452 0.726074C17.225 0.726074 22.1138 4.66477 23.2601 10.0282C23.8328 12.7081 23.447 15.5578 22.1693 17.9827C20.9396 20.3164 18.9236 22.2025 16.5116 23.2714C14.0027 24.3835 11.1224 24.5773 8.48541 23.8189C5.94141 23.0875 3.68571 21.4822 2.15001 19.3273C-1.06089 14.8222 -0.63159 8.49397 3.14601 4.45717C5.36001 2.09137 8.50461 0.726074 11.7452 0.726074ZM6.09651 13.1302L9.30651 16.4176C10.1192 17.2501 11.4038 15.9889 10.5944 15.1603L8.97471 13.5016H16.6505C17.1956 13.5016 17.6504 13.0465 17.6504 12.5017C17.6504 11.9569 17.1953 11.5018 16.6505 11.5018H9.01311L10.6649 9.85027C11.4857 9.02947 10.2131 7.75657 9.39231 8.57737L6.10401 11.8654C5.75541 12.2137 5.75211 12.7777 6.09651 13.1302Z",
    fill: "#003D67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/BackIcon.9cf310b5575779c1915707a705e07122.svg";
export { ForwardRef as ReactComponent };